import { ComponentType, ReactNode } from 'react';
import { IEntitiesLoaderProps } from './createEntitiesLoaderProvider';

export interface ILoadersProviderProps {
  loaders: Array<{ debounceTimeout?: number; component: ComponentType<IEntitiesLoaderProps> }>;
  children?: ReactNode;
}

const LoadersProvider = ({ children, loaders }: ILoadersProviderProps) => {
  return loaders.reduce((previousProvider, loader) => {
    const { component, debounceTimeout } = loader;
    const LoaderComponent = component;

    return (
      <LoaderComponent debounceTimeout={debounceTimeout}>
        {previousProvider}
      </LoaderComponent>
    );
  }, <>{children}</>);
};

export default LoadersProvider;
